import {Score} from "api/saq/types";
import {scoringService} from "api/services";
import {SaqIdentifiers, ScoringUrls} from "api/saq/resourcesUrl";
import {useQuery} from "react-query";

const fetchScore = (): Promise<Score> => scoringService.get(ScoringUrls.score);

export const useScore = (questionnaireId: string) =>
    useQuery<Score, Error, Score, string[]>([SaqIdentifiers.score], fetchScore, {
        enabled: !!questionnaireId
    });
